import axios from 'axios';
import { toFormData } from './utils';
import { setAuthToken } from './setAuthToken';

const subscriptionService = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

// Set the token from localStorage/sessionStorage
const token = localStorage.getItem('token') || sessionStorage.getItem('token');
setAuthToken(subscriptionService, token);

// Get subscription durations
export const getSubscriptionDuration = () => {
  return subscriptionService.get('/subscriptions/duration');
};

// Get all subscriptions
export const getAllSubscriptions = (data) => {
  const formData = toFormData(data);
  return subscriptionService.post('/subscriptions', formData);
};

// Update subscription
export const updateSubscription = (id, data) => {
  const formData = toFormData(data);
  return subscriptionService.put(`/subscriptions/update/${id}`, formData);
};

// Remove subscription
export const removeSubscription = (id) => {
  return subscriptionService.post(`/subscriptions/delete/${id}`);
};

export default subscriptionService;
